import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-outside-plant',
  standalone: true,
  templateUrl: './outside-plant.component.html',
  styleUrls: ['./outside-plant.component.scss'],
  imports: [
    CommonModule,
    RouterOutlet
  ],
})
export class OutsidePlantComponent {

}
